import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { api } from 'helpers/axios';
import { errorMessage } from 'helpers/common';
import * as Sentry from "@sentry/react";

const fetchGeneralSettings = createAsyncThunk('fetchGeneralSettings', async (_, { getState, rejectWithValue }) => {
  try {
    const { data, status } = await api.get('/settings/general');
    if (status === 200) return data;
  } catch (err) {
    Sentry.captureException(err);
    return rejectWithValue(errorMessage(err, 'fetch general settings'));
  }
});

export const generalSettingsSlice = createSlice({
  name: 'generalSettings',
  initialState: {
    data: null
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchGeneralSettings.fulfilled, (state, action) => {
        state.data = action.payload.data.filter((item) => item.input_type !== null && item.input_type !== '');
      });
  }
});

export const getGeneralSettings = (state) => state.generalSettings.data;

export { fetchGeneralSettings };

export default generalSettingsSlice.reducer;
